import axios from 'axios'
import { handleAxiosPromise } from '@/utils/api-common'

const NLP_BASE_URL = process.env.NLP_BASE_URL
const urlPhraseExtraction = `${NLP_BASE_URL}/facets/`
const urlRelevantKeywords = `${NLP_BASE_URL}/related-terms/`
const urlRelevantKeywordsWithContext = `${NLP_BASE_URL}/keywords/`

export { getResearchQuestionPhraseExtraction, getRelevantKeywords }

function getResearchQuestionPhraseExtraction (term) {
  return new Promise((resolve, reject) => {
    const p = handleAxiosPromise(axios.get(urlPhraseExtraction + encodeURIComponent(term)))
    p.then(
      response => {
        resolve({
          response: response.response.message
        })
      }
    )
  })
}

function getRelevantKeywords (term, question) {
  return new Promise((resolve, reject) => {
    const p = question
      ? handleAxiosPromise(axios.get(urlRelevantKeywordsWithContext + encodeURIComponent(term) + '/' + question))
      : handleAxiosPromise(axios.get(urlRelevantKeywords + encodeURIComponent(term)))
    p.then(
      response => {
        if (response.status === 1) {
          resolve({
            response: response.response.message
          })
        } else if (response.status === 3) {
          resolve({
            response: -1
          })
        }
      }
    ).catch(reason => {
      console.warn('Call to nlp-api expand/wordvectors failed:', reason)
      reject(reason)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/nlp-api-v2.js